const STORAGE_KEY = "engram_debug_logs";
const MAX_ENTRIES = 300;

function readLogs() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (error) {
    return [];
  }
}

function writeLogs(entries) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
  } catch (error) {
    // Ignore localStorage quota/write issues in production paths.
  }
}

export function logDebugEvent(scope, message, meta = {}) {
  const entries = readLogs();
  entries.push({
    at: new Date().toISOString(),
    scope,
    message,
    meta
  });

  if (entries.length > MAX_ENTRIES) {
    entries.splice(0, entries.length - MAX_ENTRIES);
  }

  writeLogs(entries);
}

export function getDebugLogs() {
  return readLogs();
}

export function clearDebugLogs() {
  writeLogs([]);
}

export function downloadDebugLogs(filename = "engram-debug-logs.json") {
  const payload = {
    generatedAt: new Date().toISOString(),
    userAgent: window.navigator.userAgent,
    logs: readLogs()
  };

  const blob = new Blob([JSON.stringify(payload, null, 2)], {
    type: "application/json"
  });
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(url);
}
